

















import Vue from 'vue';
import EntityLockModal from '@/components/shared/EntityLockModal.vue';
import { ButtonModel, Configuration, EntityType, StoreConstants } from '@/types';

export default Vue.extend({
  name: 'BuiltInListLock',
  props: {},
  data() {
    return {
      lastActivity: new Date()
    };
  },
  methods: {
    onButtonClicked() {
      this.$router.push({ name: Configuration.ListMaintenance.ListMaintenance.name });
    },
    userActivity(this: any) {
      this.lastActivity = new Date();
    }
  },
  components: { EntityLockModal },
  created(this: any) {
    this.buttons = [
      {
        caption: 'Return to list maintenance',
        id: 'returnToListMaintenance',
        class: 'mr-2',
        icon: 'undo-alt',
        variant: 'primary'
      }
    ] as ButtonModel[];

    this.entityType = EntityType.List;
    this.routeName = Configuration.ListMaintenance.ListMaintenance.name;
    this.routeText = 'Return to list maintenance';
    this.returnRouteDesc = 'list maintenance';
    this.storeNamespace = StoreConstants.ListMaintenance.ModuleName;
  }
});
